// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('resellerorder.createfulfillment', {
        url: '/fulfill/create',
        templateUrl: 'main/resellerorder/resellerorderfulfillment/createfulfillment/createfulfillment.tpl.html',
        controller: 'ResellerOrderFulfillmentProductsController as vm',
        resolve: {
        },
        params: {
        }
    });
}

// @ngInject
function ResellerOrderFulfillmentProductsController($rootScope, $scope, $window, $translate, $state, ResellerOrdersApiService, loadSpinnerService, ToasterService, CreateVariantFulfillmentDialogService,CreateVariantDeliveryDateDialogService) {
    var vm = this;

    //Properties
    vm.canAccess = $rootScope.canAccess;
    vm.selectedWarehouse = {};
    vm.fulfillableProducts = [];
    vm.filteredFulfillableProducts = [];
    vm.minimumAvailableStock = 0;
    vm.fulfillableProductsFilter = '';
    vm.pageSizes = [
        { id: 0, val: 5 },
        { id: 1, val: 10 },
        { id: 2, val: 20 },
        { id: 3, val: 50 },
        { id: 4, val: 100 },
        { id: 5, val: 200 }
    ];
    vm.selectedPageSize = vm.pageSizes[4];

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.onSelectProduct = onSelectProduct;
    vm.goToProduct = goToProduct;
    vm.showCreateVariantFulfillmentPopup = showCreateVariantFulfillmentPopup;
    vm.showCreateVariantDeliveryDatePopup = showCreateVariantDeliveryDatePopup;
    vm.filterFulfillableProducts = filterFulfillableProducts;

    activate();

    function activate() {
        $scope.$watch(function () { return vm.selectedWarehouse.id; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                loadFulfillableProducts();
                saveLastUsedWarehouseId(newValue);
            }
        });
        $scope.$watch(function () { return vm.minimumAvailableStock; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                loadFulfillableProducts();
                saveLastMinimumAvailableStock(newValue);
            }
        });
        $scope.$watch(function () { return vm.selectedPageSize.id; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                loadFulfillableProducts();
            }
        });
    }

    function onInit() {
        ResellerOrdersApiService.getWarehouses().then(function (response) {
            vm.warehouses = response.warehouses;
            var lastUsedWarehouseId = getLastUsedWarehouseId();
            vm.selectedWarehouse = _.find(vm.warehouses, function (o) { return o.id === lastUsedWarehouseId; });
            var lastMinimumAvailableStock = getLastMinimumAvailableStock();
            vm.minimumAvailableStock = lastMinimumAvailableStock;
        }, function (error) {
            ToasterService.showError(error.message);
        });
    }
    function onChanges() {
    }

    function filterFulfillableProducts() {
        console.log('fulfillableProductsFilter: "' + vm.fulfillableProductsFilter + '"');

        if (vm.fulfillableProductsFilter.trim().length > 0) {
            var searchTerm = vm.fulfillableProductsFilter.trim().toLowerCase();
            vm.filteredFulfillableProducts = _.filter(vm.fulfillableProducts, function(o) {
                return o.displayArticleNumber.toLowerCase().indexOf(searchTerm) > -1 ||
                        o.supplier.toLowerCase().indexOf(searchTerm) > -1 ||
                        o.variantDetail1Name.toLowerCase().indexOf(searchTerm) > -1 ||
                        o.articleName.toLowerCase().indexOf(searchTerm) > -1;
            });
        } else {
            vm.filteredFulfillableProducts = vm.fulfillableProducts;
        }
    }

    function showCreateVariantDeliveryDatePopup(fulfillableProduct){
        CreateVariantDeliveryDateDialogService.showDialog(fulfillableProduct, vm.selectedWarehouse, vm.minimumAvailableStock).then(function (result){
            // if (result && result.success === true) {
            //     console.log(result.itemsToFulfill);

            //     var request = {
            //         itemsToFulfill: result.itemsToFulfill
            //     };
            //     loadSpinnerService.start('mainSpinner');
            //     ResellerOrdersApiService.applyFulfillResellerOrders(request).then(function (response) {
            //         loadFulfillableProducts();
            //     }, function (error) {
            //         ToasterService.showError(error, $translate.instant('common.error'));
            //     }).then(function () {
            //         loadSpinnerService.stop('mainSpinner', { force: true });
            //     });
            // }
        });
    }

    function showCreateVariantFulfillmentPopup(fulfillableProduct) {
        CreateVariantFulfillmentDialogService.showDialog(fulfillableProduct, vm.selectedWarehouse, vm.minimumAvailableStock).then(function (result) {
            if (result && result.success === true) {
                console.log(result.itemsToFulfill);

                var request = {
                    itemsToFulfill: result.itemsToFulfill
                };
                loadSpinnerService.start('mainSpinner');
                ResellerOrdersApiService.applyFulfillResellerOrders(request).then(function (response) {
                    loadFulfillableProducts();
                }, function (error) {
                    ToasterService.showError(error, $translate.instant('common.error'));
                }).then(function () {
                    loadSpinnerService.stop('mainSpinner', { force: true });
                });
            }
        });
    }

    function goToProduct(articleId) {
        var url = $state.href('product.articles.article', {articleId: articleId});
        $window.open(url,'_blank');
    }

    function getLastUsedWarehouseId() {
        if ($window.localStorage.resellerorderfulfill_lastUsedWarehouseId) {
            var lastUsedWarehouseId = parseInt($window.localStorage.getItem('resellerorderfulfill_lastUsedWarehouseId'));
            if (isNaN(lastUsedWarehouseId)) { return undefined; }
            return lastUsedWarehouseId;
        }
        return undefined;
    }
    function saveLastUsedWarehouseId(id) {
        $window.localStorage.setItem('resellerorderfulfill_lastUsedWarehouseId', id);
    }
    function getLastMinimumAvailableStock() {
        if ($window.localStorage.resellerorderfulfill_lastMinimumAvailableStock) {
            var lastMinimumAvailableStock = parseInt($window.localStorage.getItem('resellerorderfulfill_lastMinimumAvailableStock'));
            if (isNaN(lastMinimumAvailableStock)) { return undefined; }
            return lastMinimumAvailableStock;
        }
        return undefined;
    }
    function saveLastMinimumAvailableStock(value) {
        $window.localStorage.setItem('resellerorderfulfill_lastMinimumAvailableStock', value);
    }

    function loadFulfillableProducts() {
        if (vm.selectedWarehouse && vm.selectedWarehouse.id > 0) {
            loadSpinnerService.start('mainSpinner');
            var request = {
                warehouseId: vm.selectedWarehouse.id,
                minimumAvailableStock: vm.minimumAvailableStock,
                pageSize: vm.selectedPageSize.val
            };
            ResellerOrdersApiService.getFulfillableProducts(request).then(function (response) {
                vm.fulfillableProducts = response.data.products;
                vm.filteredFulfillableProducts = response.data.products;

                //Sort on productnumber, color
                _.sortBy(vm.fulfillableProducts, ['articleNumber', 'variantDetail1Name']);
                _.sortBy(vm.filteredFulfillableProducts, ['articleNumber', 'variantDetail1Name']);

                filterFulfillableProducts();
            }, function (error) {
                console.log(error);
            }).then(function () {
                loadSpinnerService.stop('mainSpinner');
            });
        }
    }

    function onSelectProduct(product) {
        if (!product || !product.articleId || product.articleId <= 0) { return; }
    }
}

angular
    .module('resellerorder.createfulfillment', [])
    .config(stateConfig)
    .controller('ResellerOrderFulfillmentProductsController', ResellerOrderFulfillmentProductsController);
